import { useEffect } from 'react';
import { useAppStore } from '../stores';

/**
 * Drains a pending signInWithRedirect result once, when the app boots after a
 * mobile / installed-PWA OAuth redirect.
 *
 * onAuthStateChanged already establishes the resulting session, so this hook's
 * job is to provision a new user's Firestore doc and surface errors from the
 * redirect leg — which would otherwise be swallowed, since that flow completes
 * across a full-page reload with no component around to catch the rejection.
 * Mount it once at the app root.
 */
export function useRedirectResult(): void {
  useEffect(() => {
    void useAppStore.getState().auth.completeRedirectSignIn();
  }, []);
}
